<template>
  <Widget
    headline="Anträge"
    :bottom="{
      label: 'Zur Antragsübersicht',
      href: ROUTE_APPLICATIONS,
      onClick: () => $emit('onTrackingClick', '_link-Zur Antragsübersicht', 'link'),
    }"
  >
    <div v-if="applicationLoaded" :class="`${el}__widget`">
      <InViewAnimation :delay="6">
        <template v-if="neverUsed">
          <div :class="`${el}__widgetIconWrapper`">
            <Icon
              name="file-list-2-line"
              color="primaryBlue"
              size="xxl"
              :class="`${el}__widgetIcon`"
            />
          </div>

          <Copy :staticClass="`${el}__widgetCopy`" element="div" color="tertiaryLight" centered>
            {{ $t('applications.widget.copy') }}
          </Copy>
        </template>

        <Row v-else>
          <Col :xs="3" :s="2">
            <Icon name="file-list-2-line" color="primaryBlue" size="xxl" />
          </Col>
          <Col :xs="9" :s="10">
            <Copy element="div" :staticClass="`${el}__widgetElement`" color="primaryBlue" noWrap>
              {{ $t('applications.widget.geplanteAntraege') }}
              <strong>{{ getData(1) }}</strong>
            </Copy>
            <Copy element="div" :staticClass="`${el}__widgetElement`" color="primaryBlue" noWrap>
              {{ $t('applications.widget.genehmigteAntraege') }}
              <strong>{{ getData(3) }}</strong>
            </Copy>
            <Copy element="div" :staticClass="`${el}__widgetElement`" color="primaryBlue" noWrap>
              {{ $t('applications.widget.antraegeInBearbeitung') }}
              <strong>{{ getData(2) }}</strong>
            </Copy>
            <Copy element="div" :staticClass="`${el}__widgetElement`" color="primaryBlue" noWrap>
              {{ $t('applications.widget.abgelehnteAntraege') }}
              <strong>{{ getData(4) }}</strong>
            </Copy>
          </Col>
        </Row>
      </InViewAnimation>
    </div>
    <Spinner v-else size="l" insideWidget />
  </Widget>
</template>

<script>
import Widget from '@/objects/Widget';
import Icon from '@/objects/Icon';
import Copy from '@/objects/Copy';
import Spinner from '@/objects/Spinner';
import InViewAnimation from '@/components/InViewAnimation';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';

import { ROUTE_APPLICATIONS } from '@/constants/routes';
import { mapFieldsApplication } from '@/store/mapFields';

export default {
  name: 'ApplicationsWidget',
  props: {},
  components: {
    Widget,
    Icon,
    Copy,
    Spinner,
    InViewAnimation,
    Row,
    Col,
  },
  computed: {
    ...mapFieldsApplication(['applicationLoaded', 'neverUsed', 'applications']),
  },
  data() {
    return {
      ROUTE_APPLICATIONS,
      el: 'v-applications',
    };
  },
  methods: {
    getData(status) {
      return Object.entries(this.applications).filter((entry) => entry[1].status === status).length;
    },
  },
};
</script>
